import {Injectable} from "@angular/core";
import {ISettingsDTO} from "../../shared/DTOs/ISettingsDTO";
import {BehaviorSubject, Observable} from "rxjs";
import {PreviewTextService} from "./preview-text/preview-text.service";
import {EOrganizationType} from "../../shared/enums/EOrganizationType";
import {AuthService} from "./auth.service";


@Injectable({
  providedIn: "root",
})
export class SettingsService {
  public _settings = new BehaviorSubject<ISettingsDTO>(null);
  public readonly settings$: Observable<ISettingsDTO> = this._settings.asObservable();

  constructor() {}

  public getDefaultLocation(locations) {
    const selectedLocationId =  AuthService.getSelectedLocationId();
    return locations.find(({ id }) => id === selectedLocationId);
  }

  public set settings (settings: ISettingsDTO) {
    settings.selectedLocation = this.getDefaultLocation(settings.locations);
    this._settings.next(settings);
    PreviewTextService.setPreviewTexts(settings.organization.accountType ?? EOrganizationType.PERFORMANCE);
  }

  public get settings (): ISettingsDTO{
    return this._settings.value;
  }
}
